import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <a href="/products"><p>Get Started</p></a>
      <a href="/products"><h3>Sign Up Today & start exploring the endless possibilities.</h3></a>
    </div>
    {/* <div className="gpt3__cta-btn">
      <button type="button">Sign Up/Login</button>
    </div> */}
  </div>
);

export default CTA;
